var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8248 9.00005L8.7248 13.9C8.9248 14.1 9.02064 14.3334 9.01231 14.6C9.00397 14.8667 8.89981 15.1 8.69981 15.3C8.49981 15.4834 8.26647 15.5792 7.9998 15.5875C7.73314 15.5959 7.4998 15.5 7.2998 15.3L0.699805 8.70005C0.599805 8.60005 0.528971 8.49172 0.487305 8.37505C0.445638 8.25838 0.424805 8.13338 0.424805 8.00005C0.424805 7.86672 0.445638 7.74172 0.487305 7.62505C0.528971 7.50838 0.599805 7.40005 0.699805 7.30005L7.2998 0.700049C7.48314 0.516715 7.7123 0.425049 7.9873 0.425049C8.2623 0.425049 8.49981 0.516715 8.69981 0.700049C8.89981 0.900049 8.9998 1.13755 8.9998 1.41255C8.9998 1.68755 8.89981 1.92505 8.69981 2.12505L3.8248 7.00005H14.9998C15.2831 7.00005 15.5206 7.09588 15.7123 7.28755C15.904 7.47922 15.9998 7.71672 15.9998 8.00005C15.9998 8.28338 15.904 8.52088 15.7123 8.71255C15.5206 8.90422 15.2831 9.00005 14.9998 9.00005H3.8248Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.11d760667a7e8d32c6673eeae5cf7cba.svg";
export { ForwardRef as ReactComponent };